<template>
  <div
    class="highlight-element highlight-content"
    :class="[getContentAlignmentX, getContentDirection]"
  >
    <div
      class="highlight-content-inner"
      :class="getContentTextAlignment"
    >
      <div
        v-if="imageUrl"
        class="highlight-icon-container"
      >
        <img
          :src="imageUrl"
          class="highlight-icon"
          :class="getIconSize"
        >
      </div>

      <div class="highlight-text">
        <div
          v-if="header.leadline"
          class="highlight-leadline-container"
        >
          <h4 class="highlight-leadline">
            {{ header.leadline }}
          </h4>
        </div>
        <div
          v-if="header.title"
          class="highlight-title-container"
        >
          <h2 class="highlight-title">
            {{ header.title }}
          </h2>
        </div>
        <div
          v-if="header.description"
          class="highlight-description"
          v-html="header.description"
        >
        </div>
      </div>
      <div
        v-if="header.linkText"
        class="highlight-action"
      >
        <HighlightButton
          :button-type="header.buttonType"
          :button-style="header.buttonStyle"
          :icon="header.buttonIcon"
          :icon-position="header.buttonIconPosition"
          :button-size="header.buttonIconSize"
          :url="header.linkURL"
          :title="header.linkText"
        />
      </div>

    </div>
  </div>
</template>

<script>
import HighlightButton from 'dev/common-components/src/components/highlight-button/highlight-button'
import FilestorePresignedURL from '../filestore-presigned-url'

export default {
  name: 'content-header',
  components: {
    HighlightButton
  },
  mixins: [FilestorePresignedURL],
  props: {
    header: {
      type: Object,
      required: true
    },
    filestore: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      imageUrl: ''
    }
  },
  computed: {
    getContentDirection() {
      if (this.header.contentDirection) {
        return `highlight-content-${this.header.contentDirection}`
      }
      return 'highlight-content-column'
    },
    getContentAlignmentX() {
      if (this.header.alignmentX) {
        return `content-alignment-${this.header.alignmentX}`
      }
      return 'content-alignment-center'
    },
    getIconSize() {
      if (this.header.imageSize) {
        return `icon-size-${this.header.imageSize}`
      }
      return 'icon-size-standard'
    },
    getContentTextAlignment() {
      if (this.header.textAlignment) {
        return `highlight-text-${this.header.textAlignment}`
      }
      return 'highlight-text-left'
    }
  },
  watch: {
    header: {
      handler: function() {
        if (this.header.image) {
          this.updateFilestoreImagePaths()
        }
      },
      deep: true
    }
  },
  created() {
    this.updateFilestoreImagePaths()
  },
  methods: {
    updateFilestoreImagePaths() {
      this.getPreSignedURL(this.header.image).then(data => {
        this.$set(this, 'imageUrl', data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@scss/custom.scss';

  .highlight-content {
    --highlight-content-icon-size: 5em;
  }

  @include media-breakpoint-up(md) {

    .highlight-content-row {
      --highlight-content-inner-direction: row;

      .highlight-content-inner {
        align-items: center;
        width: 100%;
      }

      .highlight-icon-container {
        margin-right: 1em;
      }

      .highlight-action {
        justify-content: flex-end;
        flex-grow: 1;
      }
    }
  }

  .highlight-content-column {
    --highlight-content-inner-direction: column;

    .highlight-icon-container {
      margin-bottom: 1em;
    }

    .highlight-description {
      margin-bottom: 1em;
    }
  }

  .highlight-icon {
    width: var(--highlight-content-icon-size);

    &.icon-size-small {
      width: calc(var(--highlight-content-icon-size) * .75);
    }

    &.icon-size-standard {
      width: var(--highlight-content-icon-size);
    }

    &.icon-size-large {
      width: calc(var(--highlight-content-icon-size) * 1.25);
    }
  }

  .highlight-title {
    font-size: 2.2em;
  }

  .highlight-content {
    .highlight-content-inner {
      display: flex;
      flex-direction: var(--highlight-content-inner-direction, column);
    }
  }

  .highlight-content {
    display: flex;
    color: var(--vc-text-color);
    z-index: 3;
    position: relative;

    &.content-alignment-left {
      justify-content: flex-start;

    }

    &.content-alignment-center {
      justify-content: center;

    }

    &.content-alignment-right {
      justify-content: flex-end;
    }
  }

  .highlight-content-inner {
    &.highlight-text-left {
      justify-content: flex-start;
      text-align: left;
    }

    &.highlight-text-center {
      justify-content: center;
      text-align: center;
    }

    &.highlight-text-right {
      justify-content: flex-end;
      text-align: right;
    }
  }

  //animate highlight link, both text and button, we set up a default hover state to deal with failures on hover state colours
  //we inherit alignment from parent
  .highlight-action {
    display: flex;
    justify-content: inherit;
  }

</style>
